<template>
  <div class="ztbox">
    <!--<div class="ztheader">
    </div>-->
    <div class="ztcenter">
      <div class="centerone flex spa-bet">
        <div class="centerleft">
          <div class="leftitem">
            <img src="@/assets/images/xin/szw2.png" class="leftimg" alt />
            <div>
              <p class="lefttext1">10034个</p>
              <p class="lefttext2">思政微课</p>
            </div>
          </div>

          <div class="leftitem">
            <img src="@/assets/images/xin/szw2.png" class="leftimg" alt />
            <div>
              <p class="lefttext1">356门</p>
              <p class="lefttext2">课程数量</p>
            </div>
          </div>
          <div class="leftitem">
            <img src="@/assets/images/xin/szw2.png" class="leftimg" alt />
            <div>
              <p class="lefttext1">125个</p>
              <p class="lefttext2">专业数量</p>
            </div>
          </div>
          <div class="leftitem">
            <img src="@/assets/images/xin/szw2.png" class="leftimg" alt />
            <div>
              <p class="lefttext1">89%</p>
              <p class="lefttext2">专业覆盖率</p>
            </div>
          </div>
          <div class="leftitem">
            <img src="@/assets/images/xin/szw2.png" class="leftimg" alt />
            <div>
              <p class="lefttext1">8455人</p>
              <p class="lefttext2">参与教师</p>
            </div>
          </div>
          <div class="leftitem">
            <img src="@/assets/images/xin/szw2.png" class="leftimg" alt />
            <div>
              <p class="lefttext1">98%</p>
              <p class="lefttext2">学校覆盖率</p>
            </div>
          </div>
        </div>
        <div class="centerright">
          <div class="onetitle">
            思政微课建设情况
            <a-select v-model="year" style="width: 100px; margin-left: 10px;" @change="handleChange"
              :dropdownClassName="'customClass'">
              <a-select-option value="2024">2024</a-select-option>
              <a-select-option value="2023">2023</a-select-option>
              <a-select-option value="2022">2022</a-select-option>
              <a-select-option value="2021">2021</a-select-option>
            </a-select>
          </div>
          <div class="onebg" id="hh"></div>
        </div>
        <div class="centerright" style="width:29%;">
          <div class="onetitle2">各地区学校覆盖率</div>
          <div class="onebg" id="fgl"></div>
        </div>
      </div>
      <div class="centerone flex spa-bet">
        <div class="centeritem">
          <div class="onetitle1">微课类型分布</div>
          <div class="onebg1" id="main"></div>
        </div>
        <div class="centeritem">
          <div class="onetitle1">微课思政元素</div>
          <div class="onebg1" ref="wordChart"></div>
        </div>

        <div class="centeritem" style="width:29%;">
          <div class="onetitle2">专业建设</div>
          <div class="onebg1">
            <table class="tables">
              <thead>
                <tr>
                  <th>专业大类</th>
                  <th>专业</th>
                  <th>数量</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>装备制造类</td>
                  <td>机电技术应用</td>
                  <td>47</td>
                </tr>
                <tr>
                  <td>财经商贸类</td>
                  <td>会计</td>
                  <td>52</td>
                </tr>
                <tr>
                  <td>电子信息类</td>
                  <td>计算机应用</td>
                  <td>45</td>
                </tr>
                <tr>
                  <td>医药卫生类</td>
                  <td>护理</td>
                  <td>42</td>
                </tr>
                <tr>
                  <td>教育与体育类</td>
                  <td>学前教育</td>
                  <td>39</td>
                </tr>
                <tr>
                  <td>财经商贸类</td>
                  <td>电子商务</td>
                  <td>38</td>
                </tr>
                <tr>
                  <td>电子信息类</td>
                  <td>物联网技术应用</td>
                  <td>26</td>
                </tr>
                <tr>
                  <td>教育与体育类</td>
                  <td>运动训练</td>
                  <td>21</td>
                </tr>
                <!-- <tr>
                  <td>专业一</td>
                  <td>专业一</td>
                  <td>34</td>
                </tr>
                <tr>
                  <td>专业二</td>
                  <td>专业二</td>
                  <td>9</td>
                </tr>
                <tr>
                  <td>专业三</td>
                  <td>专业三</td>
                  <td>131</td>
                </tr>
                <tr>
                  <td>专业四</td>
                  <td>专业四</td>
                  <td>88</td>
                </tr>
                <tr>
                  <td>专业五</td>
                  <td>专业五</td>
                  <td>77</td>
                </tr>
                <tr>
                  <td>专业六</td>
                  <td>专业六</td>
                  <td>54</td>
                </tr>
                <tr>
                  <td>专业七</td>
                  <td>专业七</td>
                  <td>82</td>
                </tr>
                <tr>
                  <td>专业八</td>
                  <td>专业八</td>
                  <td>44</td>
                </tr> -->
              </tbody>
            </table>
          </div>
        </div>
        <div class="centeritem" style="width:29%;">
          <div class="onetitle2">学校建设排行</div>
          <div class="onebg1">
            <table class="tables">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>学校名称</th>
                  <th>数量</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <img src="@/assets/images/bigData/num1.png" alt />
                  </td>
                  <!-- <td>******</td> -->
                  <td>山西机电职业技术学院</td>
                  <td>163</td>
                  <!-- <td>163</td> -->
                </tr>
                <tr>
                  <td>
                    <img src="@/assets/images/bigData/num2.png" alt />
                  </td>
                  <!-- <td>******</td> -->
                  <!-- <td>9</td> -->
                  <td>山西工程职业学院</td>
                  <td>152</td>
                </tr>
                <tr>
                  <td>
                    <img src="@/assets/images/bigData/num3.png" alt />
                  </td>
                  <!-- <td>******</td> -->
                  <!-- <td>131</td> -->
                  <td>山西工程科技职业大学</td>
                  <td>151</td>
                </tr>
                <tr>
                  <td>
                    <div class="numbg">4</div>
                  </td>
                  <!-- <td>******</td>
                  <td>88</td> -->
                  <td>山西省财政税务专科学校</td>
                  <td>144</td>
                </tr>
                <tr>
                  <td>
                    <div class="numbg">5</div>
                  </td>
                  <!-- <td>******</td>
                  <td>77</td> -->
                  <td>山西职业技术学院</td>
                  <td>119</td>
                </tr>
                <tr>
                  <td>
                    <div class="numbg">6</div>
                  </td>
                  <!-- <td>******</td>
                  <td>54</td> -->
                  <td>运城职业技术大学</td>
                  <td>111</td>
                </tr>
                <tr>
                  <td>
                    <div class="numbg">7</div>
                  </td>
                  <!-- <td>******</td>
                  <td>82</td> -->
                  <td>太原市财政金融学校</td>
                  <td>110</td>
                </tr>
                <tr>
                  <td>
                    <div class="numbg">8</div>
                  </td>
                  <!-- <td>******</td>
                  <td>44</td> -->
                  <td>临汾职业技术学院</td>
                  <td>105</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import HighCharts from "highcharts";
import 'echarts-wordcloud';
export default {
  data() {
    return {
      year: "2024"
    };
  },
  mounted() {
    this.gethh();
    if (window.innerWidth > 1440) {
      // this.mgt(['30%', '70%']);
      this.glbt([70, 100]);
      // this.getMyChart5(200, 20);
    } else {
      // this.mgt(['20%', '50%']);
      this.glbt([60, 80]);
      // this.getMyChart5(140, 8);
    }
    this.getWordChart()
    this.getfgl();
  },
  methods: {
    getfgl() {
      var myChart = echarts.init(document.getElementById("fgl"));
      let option = {
        title: {
          text: ""
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          formatter: function(params) {
						const param = params[0]; // 只取第一个参数（对于单个系列）
						// const percent = ((param.value / 100) * 100).toFixed(1) + '%';
						return `${param.name}<br/>${param.value}%`;
					}
        },
        legend: {
          show: false
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: '1%',
          containLabel: true
        },
        xAxis: {
          type: "value",
          max: 100,
          axisLabel: {
            textStyle: {
              color: "#AADDFF"
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "#AADDFF"
            }
          }
        },
        yAxis: {
          type: "category",
          data: [
            "太原",
            "大同",
            "阳泉",
            "晋城",
            "朔州",
            "晋中",
            "运城",
            "忻州",
            "长治",
            "临汾",
            "吕梁"
          ],
          axisLabel: {
            textStyle: {
              color: "#AADDFF"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#68A8CC"
            }
          }
        },
        series: [
          {
            name: "",
            type: "bar",
            data: [98, 96, 86, 90, 85, 90, 88, 87, 86, 89, 80,],
            showBackground: true,
            barWidth: 20,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 1, 1, [
                { offset: 0, color: "#83bff6" },
                { offset: 0.5, color: "#188df0" },
                { offset: 1, color: "#188df0" }
              ]),
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#002F69" },
                  { offset: 0.7, color: "#002F69" },
                  { offset: 1, color: "#002F69" }
                ]),
                borderColor: '#0E48B3', // 边框颜色
                borderWidth: 2 // 边框宽度
              }
            }
          }
        ]
      };
      myChart.clear();
      myChart.setOption(option);
    },
    getMyChart5(value, value2) {
      HighCharts.chart("bt", {
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 50,
            beta: 0
          },
          backgroundColor: null
        },
        credits: {
          enabled: false
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          itemStyle: {
            color: "#fff",
            fontSize: "10"
          },
          layout: "horizontal", // 设置图例布局为水平布局
          align: "center", // 图例水平对齐方式
          verticalAlign: "top", // 图例垂直对齐方式// 设置图例区域宽度
          //	        symbolHeight: 10, // 调整图例符号高度
          //	        symbolWidth: 10, // 调整图例符号宽度
          //	        symbolRadius: 0, // 调整图例符号圆角
          //        itemMarginTop: 10,
          labelFormatter: function () {
            // 计算当前系列占比百分比
            //          var percentage = (this.y / this.series.total) * 100;
            return this.name;
          }
        },
        plotOptions: {
          pie: {
            size: value,
            showInLegend: true,
            allowPointSelect: true, //每个扇块能否选中
            depth: 30, //饼图的厚度
            borderWidth: 2,
            borderColor: "#FFFFFF", // 设置边框颜色为白色
            dataLabels: {
              distance: value2, //控制饼图外面的线的长短,为负数时文本内容在饼图内部
              enabled: true, //是否显示饼图的线形tip
              formatter: function (color) {
                console.log(this.point);
                return (
                  '<b style="color:' +
                  this.point.color +
                  ';font-size:14px;">' +
                  this.point.y +
                  "%</b></br>" +
                  this.point.name +
                  ""
                );
              },
              style: {
                color: "#fff",
                textOutline: "none",
                fontSize: 14
              }
            }
          }
        },
        series: [
          {
            // size: 150,
            name: "使用占比",
            data: [
              ["教授", 26],
              ["副教授", 18],
              ["讲师", 9],
              ["其他", 47]
            ],
            colors: ["#80CB4B", "#FFC808", "#FE8D37", "#517FD9"]
          }
        ]
      });
    },
    getWordChart() {
      const chart = echarts.init(this.$refs.wordChart);
      chart.setOption({
        series: [{
          type: 'wordCloud',
          data: [
            { 'name': '胸怀理想', 'value': 13 },
            { 'name': '建功立业', 'value': 14 },
            { 'name': '民族自信', 'value': 16 },
            { 'name': '顽强拼搏', 'value': 15},
            { 'name': '文化自信', 'value': 12 },
            { 'name': '奋发图强', 'value': 13},
            { 'name': '刚健有为', 'value': 14 },
            // { 'name': 'Vue', 'value': 100 }
            // { 'name': 'Vue', 'value': 100 },
            //  { 'name': 'Vue', 'value': 100 },
            //  { 'name': 'Vue', 'value': 100 },
            //  { 'name': 'Vue', 'value': 100 },
            //  { 'name': 'Vue', 'value': 100 },
            //  { 'name': 'Vue', 'value': 100 },
            //  { 'name': 'Vue', 'value': 100 },
            //  { 'name': 'Vue', 'value': 100 },
            //  { 'name': 'Vue', 'value': 100 },
            //  { 'name': 'Vue', 'value': 100 },
            ],
          sizeRange: [16, 30],
          textStyle: { color: () => this.randomColor(),fontSize: '18-50' }
        }]
      });
    },
    randomColor() {
       const h = Math.floor(Math.random() * 360);
        const s = 80 + Math.floor(Math.random() * 20); 
        const l = 60 + Math.floor(Math.random() * 30);
        
        // HSL转RGB再转HEX
        const a = s * Math.min(l, 100-l) / 100;
        const f = n => {
          const k = (n + h/30) % 12;
          const color = l - a * Math.max(Math.min(k-3, 9-k, 1), -1);
          return Math.round(255 * color/100).toString(16).padStart(2, '0');
        };
        return `#${f(0)}${f(8)}${f(4)}`;
    },
    handleChange() {
      this.gethh();
    },
    mgt(arr) {
      var myChart = echarts.init(document.getElementById("mg"));
      var colorList = ["#4450BB", "#5F6CE6", "#58C9F7", "#F74D4E", "#FAC231"];
      var title = [
        "思政元素1",
        "思政元素2",
        "思政元素3",
        "思政元素4",
        "思政元素5"
      ];
      var dataValue = ["20", "20", "20", "20", "20"];
      var dataList = title.map((item, index) => {
        return {
          name: item,
          value: dataValue[index],
          itemStyle: {
            color: colorList[index]
          }
        };
      });
      var center = ["50%", "50%"];
      var option = {
        color: colorList,
        series: [
          {
            type: "pie",
            center: center,
            radius: arr, // 玫瑰图半径范围
            roseType: "radius", // 玫瑰图类型
            label: {
              show: true,
              position: "outside",
              alignTo: "labelLine",
              //					            backgroundColor: '#fff',
              padding: [3, -3, 3, -3],
              formatter: function (params) {
                return `{a|${params.value}%}\n{b${params.dataIndex}|${params.name}}`;
              },
              rich: {
                a: {
                  //					                  padding: [10, 100, 10,100],
                  fontSize: "14px",
                  fontFamily: "MicrosoftYaHei",
                  fontWeight: "bold",
                  color: "#fff",
                  lineHeight: 24
                },
                b0: {
                  color: "#4450BB",
                  fontSize: "12px",
                  fontFamily: "MicrosoftYaHei",
                  fontWeight: "bold",
                  lineHeight: 24
                },
                b1: {
                  color: "#5F6CE6",
                  fontSize: "12px",
                  fontFamily: "MicrosoftYaHei",
                  fontWeight: "bold",
                  lineHeight: 24
                },
                b2: {
                  color: "#58C9F7",
                  fontSize: "12px",
                  fontFamily: "MicrosoftYaHei",
                  fontWeight: "bold",
                  lineHeight: 24
                },
                b3: {
                  color: "#F74D4E",
                  fontSize: "12px",
                  fontFamily: "MicrosoftYaHei",
                  fontWeight: "bold",
                  lineHeight: 24
                },
                b4: {
                  color: "#FAC231",
                  fontSize: "12px",
                  fontFamily: "MicrosoftYaHei",
                  fontWeight: "bold",
                  lineHeight: 24
                }
              }
            },
            data: dataList
          }
        ]
      };
      myChart.clear();
      myChart.setOption(option);
    },
    glbt(arr) {
      var data = [
        { value: 1300, name: "公共基础课", itemStyle: { color: "#80CB4B" } },
        { value: 1100, name: "专业基础课", itemStyle: { color: "#517FD9" } },
        { value: 1100, name: "专业核心课", itemStyle: { color: "#FD8839" } },
        { value: 1200, name: "实践类课程", itemStyle: { color: "#FFC808" } }
      ];

      // 初始化图表
      var myChart = echarts.init(document.getElementById("main"));

      var currentIndex = 0;
      var oldIndex;

      // 图表配置和数据
      var option = {
        tooltip: {
          trigger: "item"
        },
        legend: {
          data: ["公共基础课", "专业基础课", "专业核心课", "实践类课程"],
          textStyle: {
            color: "#fff"
          },
          orient: "horizontal",
          left: "center",
          top: "top"
        },
        series: [
          {
            name: "微课类型分布",
            type: "pie",
            radius: arr,
            center: ["50%", "60%"],
            label: {
              show: false,
              position: "center",
              formatter: function (params) {
                return (
                  "{b_style|" +
                  params.value +
                  "}\n{c_style|" +
                  params.name +
                  "}"
                );
              },
              rich: {
                b_style: {
                  padding: [0, 0, 10, 0],
                  fontSize: 18,
                  fontWeight: 400,
                  color: function (params) {
                    return params.color;
                  }
                },
                c_style: {
                  fontSize: 20,
                  fontWeight: "bold",
                  color: "#fff"
                }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
                borderWidth: 0
              },
              label: {
                show: true,
                fontSize: "14",
                fontWeight: "normal"
              }
            },
            labelLine: {
              show: false
            },
            data: data
          }
        ]
      };

      // 设置图表选项
      myChart.setOption(option);

      // 高亮饼图块函数
      function highlightPie(currentIndex, oldIndex) {
        // 取消高亮先前的饼图块
        if (oldIndex !== undefined && oldIndex !== currentIndex) {
          myChart.dispatchAction({
            type: "downplay",
            seriesIndex: 0,
            dataIndex: oldIndex
          });
        }

        // 高亮当前的饼图块
        myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: currentIndex
        });

        // 显示中心标签
        myChart.setOption({
          series: [
            {
              name: "微课类型分布",
              label: {
                show: true,
                formatter:
                  "{b_style|" +
                  data[currentIndex].name +
                  "}\n{c_style|" +
                  data[currentIndex].value +
                  "}"
              }
            }
          ]
        });
      }

      // 初始化时高亮第一个饼图块
      setTimeout(() => {
        highlightPie(0, 0);
      }, 50);

      // 绑定鼠标悬停事件
      myChart.on("mouseover", params => {
        if (params.componentType === "series" && params.seriesType === "pie") {
          oldIndex = currentIndex;
          currentIndex = params.dataIndex;
          highlightPie(currentIndex, oldIndex);
        }
      });
    },
    gethh() {
      var myChart = echarts.init(document.getElementById("hh"));
      let data1 = [],
        data2 = [],
        data3 = [],
        data4 = [],
        data5 = [];
      if (this.year == "2021") {
        data1 = [49, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0];
        data2 = [371, 1, 0, 59, 11, 0, 47, 75, 0, 30, 0];
        data3 = [142, 84, 12, 92, 42, 5, 238, 117, 12, 129, 36];
        data4 = [48, 60, 0, 29, 47, 0, 0, 15, 0, 1, 0];
        // data5 = [];
      } else if (this.year == "2022") {
        data1 = [50, 0, 0, 0, 0, 0, 0, 27, 0, 0, 0];
        data2 = [445, 13, 28, 86, 19, 2, 43, 120, 0, 40, 1];
        data3 = [355, 117, 20, 198, 114, 65, 256, 229, 120, 208, 151];
        data4 = [50, 32, 0, 18, 30, 0, 23, 39, 0, 0, 9];
      } else if (this.year == "2023") {
        data1 = [32, 0, 0, 0, 0, 0, 0, 50, 0, 0, 0];
        data2 = [510, 20, 34, 92, 17, 14, 63, 109, 0, 61, 11];
        data3 = [348, 170, 20, 154, 116, 19, 264, 228, 195, 263, 143];
        data4 = [12, 75, 0, 19, 27, 0, 10, 16, 0, 12, 0];
      } else if (this.year == "2024") {
        data1 = [20, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0];
        data2 = [197, 15, 19, 44, 10, 2, 36, 43, 9, 26, 10];
        data3 = [204, 104, 20, 130, 68, 32, 130, 143, 71, 126, 60];
        data4 = [42, 13, 0, 11, 26, 0, 15, 5, 1, 4, 0];
      }
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999"
            }
          }
        },
        toolbox: {
          show: false
        },
        legend: {
          data: ["职业本科", "高职院校", "中职院校", "技工院校", "学校覆盖率"],
          textStyle: {
            color: "#fff"
          }
        },
        grid: {
          containLabel: true,
          left: 5,
          right: 15,
          bottom: 15,
          top: 50
        },
        xAxis: [
          {
            type: "category",
            data: [
              "太原",
              "大同",
              "阳泉",
              "长治",
              "晋城",
              "朔州",
              "晋中",
              "运城",
              "忻州",
              "临汾",
              "吕梁"
            ],
            axisPointer: {
              type: "shadow"
            },
            axisLabel: {
              textStyle: {
                color: "#AADDFF"
              },
              formatter: function (value) {
                let rowMAx = 4;
                let overValue = "";
                for (let i = 0; i < value.length; i++) {
                  if (i % rowMAx == 0 && i != 0) {
                    overValue += "\n";
                    overValue += value[i];
                  } else {
                    overValue += value[i];
                  }
                }
                return overValue;
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: "#AADDFF"
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "(建设数量)",
            min: 0,
            max: 250,
            interval: 50,
            axisLabel: {
              formatter: "{value}"
            },
            nameTextStyle: {
              color: "#63A1C6"
            },
            axisLabel: {
              textStyle: {
                color: "#63A1C6"
              }
            },
            axisLine: {
              lineStyle: {
                color: "#AADDFF"
              }
            }
          },
          {
            type: "value",
            name: "(学校覆盖率)",
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: "{value}%"
            },
            nameTextStyle: {
              color: "#63A1C6"
            },
            axisLine: {
              lineStyle: {
                color: "#AADDFF"
              }
            },
            axisLabel: {
              textStyle: {
                color: "#63A1C6"
              }
            }
          }
        ],
        series: [
          {
            name: "职业本科",
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value + "";
              }
            },
            itemStyle: {
              normal: {
                color: "#FF9C00"
              }
            },
            data: data1
          },
          {
            name: "高职院校",
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value + "";
              }
            },
            itemStyle: {
              normal: {
                color: "#0096FF"
              }
            },
            data: data2
          },
          {
            name: "中职院校",
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value + "";
              }
            },
            itemStyle: {
              normal: {
                color: "#1FD84B"
              }
            },
            data: data3
          },
          {
            name: "技工院校",
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value + "";
              }
            },
            itemStyle: {
              normal: {
                color: "#FFC808"
              }
            },
            data: data4
          },
          {
            name: "学校覆盖率",
            type: "line",
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + "%";
              }
            },
            lineStyle: {
              color: "#38CEC1" // 修改折线颜色
            },
            itemStyle: {
              color: "#fff", // 点的填充颜色
              borderColor: "#38CEC1", // 点的描边颜色
              borderWidth: 2 // 描边宽度
            },
            data: [98, 96, 95, 88, 89, 80, 85, 96, 88, 89, 84]
          }
        ]
      };
      myChart.clear();
      myChart.setOption(option);
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin: 0px;
  padding: 0px;
}

.flex {
  display: flex;
}

.spa-bet {
  justify-content: space-between;
}

.numbg {
  width: 24px;
  height: 26px;
  margin: 7px auto;
  background: url("../../assets/images/bigData/numbg.png") no-repeat;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
  line-height: 26px;
  color: #a5b2c8;
}

.ztbox {
  height: auto;
  /*background: url("../../assets/images/bigdatas/banner.png") no-repeat;
  background-repeat: no-repeat;*/
  background-size: 100% 100%;
  /* padding:0px 20px 20px;*/
  box-sizing: border-box;
  flex: 1;

  /*.ztheader{
  	 height:80px;
  	 margin-bottom:10px;
  }*/
  .ztcenter {
    .centerleft {
      width: 216px;
      height: auto;

      .leftitem {
        width: 216px;
        height: 64px;
        background: url("../../assets/images/xin/szw1.png") no-repeat;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-bottom: 10px;
        overflow: hidden;
        padding: 5px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .leftimg {
          width: 43px;
          height: 43px;
          margin-right: 10px;
        }

        .lefttext1 {
          font-weight: bold;
          font-size: 20px;
          color: #ffd70e;
          line-height: 30px;
        }

        .lefttext2 {
          font-size: 16px;
          color: #ffffff;
          line-height: 24px;
        }
      }
    }

    .centerright {
      width: calc((71% - 236px));
      height: 434px;
      margin-bottom: 10px;

      .onetitle {
        height: 48px;
        background: url("../../assets/images/xin/szw3.png") no-repeat;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        padding-left: 30px;
        line-height: 48px;
        font-weight: bold;
        font-size: 20px;
        color: #02f4f5;
        display: flex;
        align-items: center;
      }

      .onebg {
        height: 386px;
        background: url("../../assets/images/xin/szw4.png") no-repeat;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        padding: 8px;
        box-sizing: border-box;
      }
    }

    .centeritem {
      width: 20%;
      height: auto;
    }

    .onetitle1 {
      height: 48px;
      background: url("../../assets/images/xin/szw5.png") no-repeat;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding-left: 30px;
      line-height: 48px;
      font-weight: bold;
      font-size: 20px;
      color: #02f4f5;
    }

    .onetitle2 {
      height: 48px;
      background: url("../../assets/images/xin/szw6.png") no-repeat;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding-left: 30px;
      line-height: 48px;
      font-weight: bold;
      font-size: 20px;
      color: #02f4f5;
    }

    .onebg1 {
      height: 396px;
      background: url("../../assets/images/xin/szw7.png") no-repeat;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding: 8px;
      box-sizing: border-box;
    }

    .tables {
      width: 100%;

      thead {
        tr {
          background-color: #082569;
          height: 50px;

          th {
            width: 25%;
            height: 50px;
            line-height: 50px;
            text-align: center;
            font-size: 16px;
            color: #8298fb;
          }
        }
      }

      tbody {
        tr {
          height: 40px;
          border-bottom: 1px solid #213e78;

          td {
            width: 25%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 16px;
            color: #fff;
            white-space: nowrap;
            /* 不换行 */
            overflow: hidden;
            /* 隐藏超出部分 */
            text-overflow: ellipsis;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1440px) and (min-width: 1367px) {

    .onetitle,
    .onetitle1,
    .onetitle2 {
      font-size: 18px !important;
    }
  }

  @media screen and (max-width: 1366px) {

    .onetitle,
    .onetitle1,
    .onetitle2 {
      font-size: 16px !important;
    }

    .lefttext1 {
      font-size: 18px !important;
    }

    .lefttext2 {
      font-size: 14px !important;
    }

    .tables {
      width: 100%;

      thead {
        tr {
          background-color: #082569;
          height: 50px;

          th {
            width: 25%;
            height: 50px;
            line-height: 50px;
            text-align: center;
            font-size: 14px !important;
            color: #8298fb;
          }
        }
      }

      tbody {
        tr {
          height: 40px;
          border-bottom: 1px solid #213e78;

          td {
            width: 25%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 14px !important;
            color: #fff;
            white-space: nowrap;
            /* 不换行 */
            overflow: hidden;
            /* 隐藏超出部分 */
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}

::v-deep .ant-select-selection {
  background-color: #01297d;
  color: #fff;
  border-color: #2669e6;
}

::v-deep .ant-select-dropdown {
  background-color: #01297d;
  color: #fff;
}

::v-deep .ant-select-arrow {
  background-color: #01297d;
  color: #fff;
}

::v-deep .ant-radio-button-wrapper {
  color: #999;
  background-color: #0d308d;
  border-color: #ffffff00;
  border-radius: 0;
}
</style>

<style lang="scss">
.customClass {
  background: #01297d;

  .ant-select-dropdown-menu-item {
    background-color: #01297d;
    color: #fff;

    &:not(:last-child) {
      border-bottom: 1px solid #999;
    }

    &:hover:not(.ant-select-dropdown-menu-item-disabled) {
      background-color: #0f5bff;
    }
  }
}
</style>